import WebStorageCache from 'web-storage-cache'

type CacheType = 'localStorage' | 'sessionStorage'

export const STORAGE_KEYS = {
  // 用户信息
  USER_INFO: 'his-user',
  // 用户信息-记住密码
  USER_INFO_PHONE: 'his-user-phone',
  // 系统主题
  APP_INFO: 'his-app',
  // 用户权限
  PERMISSION_INFO: 'his-permission',
  // 主导航栏
  SIDEBAR_INFO: 'his-sideber',
  // 病历数据
  BINGLI_DATA: 'his-bingli-data',
  // 字典数据
  DICT_DATA: 'his-dict-data',
  // 预约挂号
  REGISTER_INFO: 'his-register',
  // 问诊信息
  OUTPATIENTS_INFO: 'his-outpatients',
  // 库存信息
  INVENTORY_INFO: 'his-inventory',
} as const

export const useCache = (type: CacheType = 'localStorage') => {
  const wsCache: WebStorageCache = new WebStorageCache({
    storage: type,
  })
  return {
    wsCache,
  }
}
